import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllFakultasDropdown = createAsyncThunk(
  "fakultas/GetAllFakultasDropdown",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}/master/fakultas`);
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllFakultas = createAsyncThunk(
  "fakultas/GetAllFakultas",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}/master/fakultas/all?${data.url}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleFakultas = createAsyncThunk(
  "fakultas/GetSingleFakultas",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/fakultas/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const CreateFakultas = createAsyncThunk(
  "fakultas/CreateFakultas",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}master/fakultas`,
        {
          nama: data.nama,
          kode: data.kode,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const EditFakultas = createAsyncThunk(
  "fakultas/EditFakultas",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${api}master/fakultas/${data.id}`,
        {
          nama: data.nama,
          kode: data.kode,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const DeleteFakultas = createAsyncThunk(
  "fakultas/DeleteFakultas",
  async (data, thunkAPI) => {
    let listData;
    try {
      const responseDelete = await axios.delete(
        `${api}master/fakultas/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );

      if (responseDelete.data.success) {
        listData = await axios.get(`${api}/master/fakultas/all?${data.url}`, {
          headers: {
            Authorization: data.token,
          },
        });

        return {
          delete: responseDelete.data,
          meta: listData.data.meta,
          items: listData.data.items,
        };
      }
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const fakultasSlice = createSlice({
  name: "fakultas",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all fakultas dropdown
    builder.addCase(GetAllFakultasDropdown.pending, loadingHandler);
    builder.addCase(GetAllFakultasDropdown.fulfilled, fulfilledHandler);
    builder.addCase(GetAllFakultasDropdown.rejected, rejectedHandler);
    // get all fakultas
    builder.addCase(GetAllFakultas.pending, loadingHandler);
    builder.addCase(GetAllFakultas.fulfilled, fulfilledHandler);
    builder.addCase(GetAllFakultas.rejected, rejectedHandler);
    // get Single fakultas
    builder.addCase(GetSingleFakultas.pending, loadingHandler);
    builder.addCase(GetSingleFakultas.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleFakultas.rejected, rejectedHandler);
    // create fakultas
    builder.addCase(CreateFakultas.pending, loadingHandler);
    builder.addCase(CreateFakultas.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(CreateFakultas.rejected, rejectedHandler);
    // edit fakultas
    builder.addCase(EditFakultas.pending, loadingHandler);
    builder.addCase(EditFakultas.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isEdit: true });
    });
    builder.addCase(EditFakultas.rejected, rejectedHandler);
    // delete fakultas
    builder.addCase(DeleteFakultas.pending, loadingHandler);
    builder.addCase(DeleteFakultas.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isDelete: true });
    });
    builder.addCase(DeleteFakultas.rejected, rejectedHandler);
  },
});

export const { reset } = fakultasSlice.actions;
export default fakultasSlice.reducer;
